import React, { useEffect, useMemo, useState } from 'react';
import LandingSection from './LandingSection';
import LandingCard from './LandingCard';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../ui/carousel';

const SHOTS = [
  { title: 'Dashboard', subtitle: 'Overview cards and quick actions' },
  { title: 'Attendance', subtitle: 'Fast marking and reports' },
  { title: 'Fees', subtitle: 'Collections, dues and receipts' },
  { title: 'Reports', subtitle: 'Exports and PDFs' },
  { title: 'Timetable', subtitle: 'Schedules by class/teacher' },
  { title: 'Student Profile', subtitle: 'All details in one place' },
  { title: 'Exam Result', subtitle: 'Marks entry and analytics' },
  { title: 'Announcements', subtitle: 'School-wide updates' },
];

function CarouselDots({ count, active }) {
  return (
    <div className="mt-4 flex justify-center gap-1.5">
      {Array.from({ length: count }).map((_, i) => (
        <span
          key={i}
          className={`h-1.5 rounded-full transition-all ${
            i === active ? 'w-6 bg-blue-400/80' : 'w-1.5 bg-white/20'
          }`}
        />
      ))}
    </div>
  );
}

export default function LandingScreenshots() {
  const [api, setApi] = useState(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!api) return undefined;
    const onSelect = () => setActive(api.selectedScrollSnap());
    onSelect();
    api.on('select', onSelect);
    return () => api.off('select', onSelect);
  }, [api]);

  const items = useMemo(() => SHOTS, []);

  return (
    <LandingSection
      id="screenshots"
      title="Screenshots"
      subtitle="A quick peek at the experience across key modules."
      innerClassName=""
      withTopDivider
    >
      <div className="relative">
        <Carousel setApi={setApi} opts={{ align: 'start', loop: true }}>
          <CarouselContent className="-ml-3">
            {items.map((s) => (
              <CarouselItem key={s.title} className="basis-[90%] pl-3 sm:basis-[65%] lg:basis-[45%]">
                <LandingCard className="p-5" hover>
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <p className="text-sm font-semibold text-white">{s.title}</p>
                      <p className="mt-1 text-xs text-white/55">{s.subtitle}</p>
                    </div>
                    <div className="h-10 w-14 rounded-xl border border-white/10 bg-white/[0.03]" />
                  </div>
                  <div className="mt-4 aspect-[16/10] w-full rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.05] to-white/[0.02]" />
                  <p className="mt-3 text-xs text-white/45">
                    Mockup preview — replace with real screenshots when available.
                  </p>
                </LandingCard>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden lg:flex border-white/10 bg-[#050816]/80 text-white hover:bg-white/10" />
          <CarouselNext className="hidden lg:flex border-white/10 bg-[#050816]/80 text-white hover:bg-white/10" />
        </Carousel>
        <CarouselDots count={items.length} active={active} />
      </div>
    </LandingSection>
  );
}

